import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],
    });
    $('.box').boxWidget();

    //this.consultar();

  },

  computed: {
    reporte: function () {
      return (
        "/reportes/info/eventos?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta+
        "&estado=" +
        this.f_c.estado
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/info/eventos', this.f_c)
        .then(response => {

          if (response.data.status == 1) {
            response.data.data.forEach(e => {
               
                e[7] = this.num_to_many(e[7]);

                e[10] = this.num_to_many(e[10]);
                e[11] = this.num_to_many(e[11]);
                e[12] = this.num_to_many(e[12]);
                e[13] = this.num_to_many(e[13]);


              
              this.tbv.row.add(e);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/infoEventos/tventas/index.js